// The business's type and homes, read once and shared by every screen that needs them — the menu, the business page,
// the setup wizard and the actions page (Stage 4.2b O1b step 7). A save answers with the new state, which every
// screen holding it hears at once, so switching a home on shows it in the menu without a reload.
//
// KEPT PER SIGNED-IN ACCOUNT: a second account signing in on the same tab is never shown the first one's homes.
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosInstance";

const unwrap = (p) => p.then(({ data }) => data);
let held = { user: null, business: null };
let pending = null;
const listeners = new Set();
const publish = (user, business) => { held = { user, business }; for (const fn of listeners) fn(held); };

export const getBusiness = () => unwrap(axiosInstance.get("/ai/business"));
export function loadBusiness(user) {
  if (pending?.user === user) return pending.promise;
  const promise = getBusiness().then((b) => { publish(user, b); return b; }).finally(() => { if (pending?.promise === promise) pending = null; });
  pending = { user, promise };
  return promise;
}
export async function saveBusiness(user, patch) {
  const b = await unwrap(axiosInstance.patch("/ai/business", patch));
  publish(user, b);
  return b;
}

// `user`: the signed-in account's id. Answers null until the business has been read for that account.
export default function useBusiness(user, { enabled = true } = {}) {
  const [state, setState] = useState(held);
  useEffect(() => {
    if (!enabled || user == null) return undefined;
    listeners.add(setState);
    if (held.user !== user || !held.business) loadBusiness(user).catch(() => { /* the menu keeps every home: no change */ });
    return () => { listeners.delete(setState); };
  }, [user, enabled]);
  return state.user === user ? state.business : null;
}
